import { AveragePlayerScore } from '__generated__/globalTypes';

export type TotalAveragePlayerScore =
  | typeof AveragePlayerScore.LAST_TEN_PLAYED_SO5_AVERAGE_SCORE
  | typeof AveragePlayerScore.LAST_FIVE_SO5_AVERAGE_SCORE
  | typeof AveragePlayerScore.LAST_FIFTEEN_SO5_AVERAGE_SCORE
  | typeof AveragePlayerScore.SEASON_AVERAGE_SCORE
  | typeof AveragePlayerScore.LAST_FORTY_SO5_AVERAGE_SCORE;

export const averageScoreCount = {
  [AveragePlayerScore.LAST_FORTY_SO5_AVERAGE_SCORE]: 40,
  [AveragePlayerScore.LAST_FIFTEEN_SO5_AVERAGE_SCORE]: 15,
  [AveragePlayerScore.LAST_TEN_PLAYED_SO5_AVERAGE_SCORE]: 10,
  [AveragePlayerScore.LAST_FIVE_SO5_AVERAGE_SCORE]: 5,
  [AveragePlayerScore.SEASON_AVERAGE_SCORE]: null,
};
